module.exports = ".product-checkbox > div {\n  position: absolute; }\n\n.loyalized-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.loyalized-container > div {\n    margin: 10px;\n    width: 100%; }\n\n.loyalization-config-input {\n  margin-left: 20px;\n  width: 70%;\n  max-width: 600px; }\n\nh5 {\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 14px;\n  font-weight: 300; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/loyalization/loyalization.component.scss
// module id = ./src/app/modules/loyalization/loyalization.component.scss
// module chunks = main